import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { CDialog, Pane, Text } from "shared";
import { paneStyles } from "shared/styles";
import { useTranslation } from "react-i18next";
import ChangePhysicianForm from "./ChangePhysicianForm";
import { usePhysicians } from "routes/patient/queries/usePhysicians";

const ChangePhysician: React.VFC = () => {
  const [isOpen, setOpen] = useState(false);
  const closeDialog = () => setOpen(false);
  const openDialog = () => setOpen(true);
  const { t } = useTranslation();
  const { data, isLoading } = usePhysicians();
  // @ts-ignore
  const currentPhysician = data?.current?.id ? `${data?.current?.first_name} ${data?.current?.last_name}` : "";

  return (
    <>
      <Pane dark mb={2} className={paneStyles.grid}>
        <Text light>{t("patients.roles.physician")}:</Text>
        <Text bold>{currentPhysician}</Text>

        <Button onClick={openDialog} aria-label="Change physician">
          {t("buttons.change")}
        </Button>
        <CDialog maxWidth="xs" fullWidth open={isOpen} onClose={closeDialog} aria-labelledby="change-physician">
          <ChangePhysicianForm
            // @ts-ignore
            physicians={data?.available}
            physiciansIsLoading={isLoading}
            onClose={closeDialog}
          />
        </CDialog>
      </Pane>
    </>
  );
};

export default ChangePhysician;
